import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants } from 'src/app/shared/app-constants';

@Component({
  selector: 'app-rtsp-url-player',
  templateUrl: './rtsp-url-player.component.html',
  styleUrls: ['./rtsp-url-player.component.scss']
,
  standalone: false
})
export class RtspUrlPlayerComponent implements OnInit {

  headerName: string = 'Check RTSP';
  loading: boolean = false;
  thumbnailImage: string = '';
  errorMessage: string = '';
  rtspData: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RtspUrlPlayerComponent>,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.checkTheRTSPStream();
    }
  }

  checkTheRTSPStream() {
    this.spinner.activate();
    this.loading = true;
    this.camService.rtspStream(this.data?.streamUrl).subscribe((response: any) => {
      if (response && response.success) {
        this.rtspData = response;
        this.spinner.deactivate();
        this.loading = false;
        this.thumbnailImage = response.thumbnail;
        this.errorMessage = "";
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.thumbnailImage = response.thumbnail;
        this.errorMessage = response.message;
      }
    }, (err) => {
      if (err) {
        this.spinner.deactivate();
        this.loading = false;
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }

}
